import {Loader, Modal} from '@mantine/core';

type Props = {
  opened: boolean;
  onSubmit: () => void;
  onClose: () => void;
  isLoading: boolean;
  isNotification?: boolean;
};

export const LastConfirmModal: React.FC<Props> = ({
  opened,
  onSubmit,
  onClose,
  isLoading,
  isNotification,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      size={668}
      padding={0}
      radius={12}
      centered={true}
    >
      <div className="p-24">
        <p className="text-md text-black-1 font-bold text-center leading">
          本当によろしいですか？
        </p>
        {isLoading ? (
          <div className="flex justify-center items-center h-52">
            <Loader color="gray" />
          </div>
        ) : (
          <div className="flex justify-center items-center mt-16">
            <button
              onClick={onClose}
              className="w-[128px] bg-black-4 py-12 px-24 text-base text-white leading font-bold rounded-full hover:opacity-80 mr-24"
            >
              キャンセル
            </button>
            <button
              onClick={onSubmit}
              className={`w-[128px] ${isNotification ? 'bg-notification-1' : 'bg-primary-1'} py-12 px-24 text-base text-white leading font-bold rounded-full hover:opacity-80 mr-24`}
            >
              OK
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};
